import { call, put, takeEvery, fork } from 'redux-saga/effects';

import * as actionTypes from './action-types';
import * as actions from './actions';
import * as api from 'api/config/companies';
import callApi from 'store/api/saga';
import { addMessage } from 'store/features/common/flash/actions';
import { messageTypes } from 'store/features/common/flash/builder';

function* fetchCompaniesVerificationDetails({ payload }) {
  yield put(actions.fetchCompaniesVerificationDetails.start(payload));

  try {
    const response = yield call(callApi, api.fetchCompaniesVerificationDetails(payload));

    if (response && response.companies) {
      yield put(
        actions.fetchCompaniesVerificationDetails.success({
          input: payload,
          result: {
            companies: response.companies,
            totalCompanies: response.totalCompanies,
            matchingCompanies: response.matchingCompanies,
          },
        })
      );
    }
  } catch (error) {
    yield put(actions.fetchCompaniesVerificationDetails.failure({ input: payload, error }));
    yield put(addMessage({ kind: messageTypes.danger, content: error.message }));
  }
}

function* watchfetchCompaniesVerificationDetails() {
  yield takeEvery(
    actionTypes.FETCH_COMPANIES_VERIFICATION_DETAILS.REQUEST,
    fetchCompaniesVerificationDetails
  );
}

export default function* companiesVerificationSaga() {
  yield fork(watchfetchCompaniesVerificationDetails);
}



// WEBPACK FOOTER //
// ./src/store/features/companies-verification-listings/saga.js